<div class="articles-section" *ngIf="hebdo || data || echo">
  <div class="section-header text-center">
    <h2>Nos derniers articles</h2>
    <p>Explorez nos rubriques AfroTech Hebdo, Data & Echo</p>
  </div>

  <div class="articles-grid">
    <!-- Hebdo -->
    <a class="article-card" *ngIf="hebdo" [routerLink]="['/news', hebdo.attributes.slug]">
      <img
        [src]="getImage(hebdo.attributes)"
        alt="AfroTech Hebdo"
        class="article-img"
        width="600"
        height="350"
      />
      <div class="article-content">
        <h3>AfroTech Hebdo</h3>
        <p class="article-snippet">{{ hebdo.attributes.excerpt }}</p>
        <span class="article-link">Lire la suite →</span>
      </div>
    </a>

    <!-- Data -->
    <a class="article-card" *ngIf="data" [routerLink]="['/news', data.attributes.slug]">
      <img [src]="getImage(data.attributes)" alt="AfroTech Data" class="article-img" />
      <div class="article-content">
        <h3>AfroTech Data</h3>
        <p class="article-snippet">{{ data.attributes.excerpt }}</p>
        <span class="article-link">Lire la suite →</span>
      </div>
    </a>

    <!-- Echo -->
    <a class="article-card" *ngIf="echo" [routerLink]="['/news', echo.attributes.slug]">
      <img [src]="getImage(echo.attributes)" alt="AfroTech Echo" class="article-img" />
      <div class="article-content">
        <h3>AfroTech Echo</h3>
        <p class="article-snippet">{{ echo.attributes.excerpt }}</p>
        <span class="article-link">Lire la suite →</span>
      </div>
    </a>
  </div>
</div>
